import AppLaundryWrapper from './Views/AppLaundryWrapper/LaundryPageWrapper'
import CheckInPageWrapper from './Views/CheckInWrapper/CheckInPageWrapper'
import CheckOutPageWrapper from './Views/CheckOutWrapper/CheckOutPageWrapper'
import EquipmentPageWrapper from './Views/EquipmentWrapper/EquipmentPageWrapper'
import InspectPageWrapper from './Views/MaintenanceInspectWrapper/InspectPageWrapper'
import LaundryBatchPageWrapper from './Views/LaundryBatch/LaundryBatchPageWrapper'
import LaundryGenerateBatchPageWrapper from './Views/LaundryGenerateBatch/LaundryGenerateBatchPageWrapper'
import LaundryPageWrapper from './Views/LaundryWrapper/LaundryPageWrapper'
import LaundryTimePageWrapper from './Views/LaundryTimeWrapper/LaundryTimePageWrapper'
import LaundryFrecuencyPageWrapper from './Views/LaundryFrecuencyWrapper/LaundryFrecuencyPageWrapper'
import LaundryGenerateBillingPageWrapper from './Views/LaundryGenerateBillingWrapper/LaundryGenerateBillingPageWrapper'
import LaundryBillingPageWrapper from './Views/LaundryBillingWrapper/LaundryBillingPageWrapper'
import LaundryOperationPageWrapper from './Views/LaundryOperationWrapper/LaundryOperationPageWrapper'
import LaundryOutPageWrapper from './Views/LaundryOutWrapper/LaundryOutPageWrapper'
import LaundryReceptionPageWrapper from './Views/LaundryReceptionWrapper/LaundryReceptionPageWrapper'
import PointPageWrapper from './Views/PointWrapper/PointPageWrapper'
import ServicePageWrapper from './Views/ServiceWrapper/ServicePageWrapper'
import SupplierPageWrapper from './Views/SupplierWrapper/SupplierPageWrapper'
import StartPageWrapper from './StartPageWrapper'
import LaundryConfigHoursPageWrapper from './Views/LaundryConfigHoursWrapper/LaundryConfigHoursPageWrapper'
import LaundryConfigDaysPageWrapper from './Views/LaundryConfigDaysWrapper/ConfigDaysPageWrapper'
import DeliveryClothesWrapper from './Views/DeliveryClothes/DeliveryClothesWrapper'
import ReportValorationPageWrapper from './Views/ReportValorationWrapper/ReportValuationWrapper'
import ManagementSequentialPageWrapper from './Views/ManagementSequentialWrapper/ManagementSequentialPageWrapper'

export const ListWrappers = {
  'app-order-laundry': <AppLaundryWrapper />,
  'generate-batch': <LaundryGenerateBatchPageWrapper />,
  batch: <LaundryBatchPageWrapper />,
  checkIn: <CheckInPageWrapper />,
  checkOut: <CheckOutPageWrapper />,
  equipment: <EquipmentPageWrapper />,
  inspect: <InspectPageWrapper />,
  laundry: <LaundryPageWrapper />,
  out: <LaundryOutPageWrapper />,
  operation: <LaundryOperationPageWrapper />,
  point: <PointPageWrapper />,
  reception: <LaundryReceptionPageWrapper />,
  reportFrecuency: <LaundryFrecuencyPageWrapper />,
  reportTime: <LaundryTimePageWrapper />,
  reportBilling: <LaundryBillingPageWrapper />,
  generateReportBilling: <LaundryGenerateBillingPageWrapper />,
  supplier: <SupplierPageWrapper />,
  start: <StartPageWrapper />,
  service: <ServicePageWrapper />,
  'configuration-hours': <LaundryConfigHoursPageWrapper />,
  'configuration-days-laundry': <LaundryConfigDaysPageWrapper />,
  'delivery-clothes-bed': <DeliveryClothesWrapper />,
  'report-valoration': <ReportValorationPageWrapper />,
  'management-sequential': <ManagementSequentialPageWrapper />,
} as any

export const renderPanelContent = (key: string | undefined) => {
  let component = <></>
  if (key) {
    component = ListWrappers[key]
  }
  return component
}
